export const CASHBACK_ALLOWED_OPTIONS = [
  { value: 0, label: "Not Allowed" },
  { value: 1, label: "Partial / Cash Payment Only" },
  { value: 2, label: "All Allowed" },
];

export const getCashbackAllowedLabel = (type) => {
  const normalizedType = type ?? 0;
  return (
    CASHBACK_ALLOWED_OPTIONS.find((o) => o.value === normalizedType)?.label ??
    "Not Allowed"
  );
};
